import { GenericFilter } from '@/components/GenericFilter';
import type {
  ListMaterialTypeFilterType,
  ListMaterialTypeFilterTypeWithValues,
} from '@shelflix/schemas/materialType/list';

export function MaterialTypeFilter({
  onChange,
}: {
  onChange: (filters: ListMaterialTypeFilterTypeWithValues) => void;
}) {
  const options: ListMaterialTypeFilterType = {
    search: {
      label: 'Nome',
      fields: ['name'],
    },
    filter: [
      {
        label: 'Status',
        field: { name: 'active', condition: 'equals' },
        items: [
          { text: 'Ativo', value: true },
          { text: 'Inativo', value: false },
        ],
      },
    ],
  };

  return <GenericFilter options={options} onChange={onChange} />;
}
